"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Highlighter = _interopRequireDefault(require("./Highlighter.react"));

var _Menu = _interopRequireDefault(require("./Menu.react"));

var _MenuItem = _interopRequireDefault(require("./MenuItem.react"));

var _utils = require("../utils");

var propTypes = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: _propTypes.default.string,

  /**
   * Prompt displayed when large data sets are paginated.
   */
  paginationText: _propTypes.default.string,

  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: _propTypes.default.func
};
var defaultProps = {
  newSelectionPrefix: 'New selection: ',
  paginationText: 'Display additional results...',
  renderMenuItemChildren: function renderMenuItemChildren(option, props, idx) {
    return _react.default.createElement(_Highlighter.default, {
      search: props.text
    }, (0, _utils.getOptionLabel)(option, props.labelKey));
  }
};

var TypeaheadMenu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(TypeaheadMenu, _React$Component);

  function TypeaheadMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderMenuItem", function (option, idx) {
      var _this$props = _this.props,
          labelKey = _this$props.labelKey,
          newSelectionPrefix = _this$props.newSelectionPrefix,
          paginationText = _this$props.paginationText,
          renderMenuItemChildren = _this$props.renderMenuItemChildren,
          text = _this$props.text;
      var label = (0, _utils.getOptionLabel)(option, labelKey);
      var menuItemProps = {
        disabled: (0, _utils.getOptionProperty)(option, 'disabled'),
        key: idx,
        label: label,
        option: option,
        position: idx
      };

      if (option.customOption) {
        return _react.default.createElement(_MenuItem.default, (0, _extends2.default)({}, menuItemProps, {
          className: "rbt-menu-custom-option",
          label: newSelectionPrefix + label
        }), newSelectionPrefix, _react.default.createElement(_Highlighter.default, {
          search: text
        }, label));
      }

      if (option.paginationOption) {
        return [_react.default.createElement(_Menu.default.Divider, {
          key: "pagination-item-divider"
        }), _react.default.createElement(_MenuItem.default, (0, _extends2.default)({}, menuItemProps, {
          className: "rbt-menu-pagination-option",
          key: "pagination-item",
          label: paginationText
        }), paginationText)];
      }

      return _react.default.createElement(_MenuItem.default, menuItemProps, renderMenuItemChildren(option, _this.props, idx));
    });
    return _this;
  }

  var _proto = TypeaheadMenu.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        labelKey = _this$props2.labelKey,
        newSelectionPrefix = _this$props2.newSelectionPrefix,
        options = _this$props2.options,
        renderMenuItemChildren = _this$props2.renderMenuItemChildren,
        menuProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["labelKey", "newSelectionPrefix", "options", "renderMenuItemChildren"]);
    return (// $FlowFixMe: Improve typing for spread props.
      _react.default.createElement(_Menu.default, menuProps, options.map(this._renderMenuItem))
    );
  };

  return TypeaheadMenu;
}(_react.default.Component);

(0, _defineProperty2.default)(TypeaheadMenu, "propTypes", propTypes);
(0, _defineProperty2.default)(TypeaheadMenu, "defaultProps", defaultProps);
var _default = TypeaheadMenu;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/components/TypeaheadMenu.react.js
// module id = 354
// module chunks = 0